import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-unknown-payment-form',
  templateUrl: './unknown-payment-form.component.html',
  styleUrls: ['./unknown-payment-form.component.scss']
})
export class UnknownPaymentFormComponent implements OnInit {

  @Input() modal = false;
  @Output() saveEvent = new EventEmitter();
  public banks;
  public data: any = {};
  @ViewChild('f') f : NgForm

  constructor(private http: HttpService) { 
    this.banks = [];
  }

  ngOnInit(): void {
    this.init();
  }

  async init() {
    this.banks = await this.http.post("/admin/setting/bank/get");
    this.data.bank = this.banks[0]['id']
  }

  async submit() {
    await this.http.post("/admin/unknow-payment/insert", this.data);

    if(this.modal) {
      this.saveEvent.emit(true)
      return;
    }

    await this.f.resetForm();
    await this.init();
  }

}
